import { capitalize } from 'lodash';

import ColorPicker from 'components/shared/ColorPicker/ColorPicker';
import Input from 'components/shared/Input/Input';
import Select from 'components/shared/Select/Select';
import Textarea from 'components/shared/Textarea/Textarea';

export default function EditKiosk({ formik, practitioners }) {
  const statuses = [
    {
      value: 'active',
      label: 'Active'
    },
    {
      value: 'inactive',
      label: 'Inactive'
    }
  ];

  return (
    <div className="flex flex-col gap-4">
      <div className="flex flex-col gap-2">
        <p className="font-500 text-neutral-900">Basic Information</p>
        <p className="text-sm text-neutral-700">
          Manage your basic details to keep your profile accurate and up to date.
        </p>
      </div>
      <div className="flex gap-2">
        <ColorPicker
          color={formik?.values?.color}
          onChange={(color) => formik.setFieldValue('color', color)}
          label="Color"
        />
        <Input
          name="name"
          className="flex-1"
          label="Kiosk Name"
          type="text"
          placeholder="Enter Kiosk name"
          required
          value={formik?.values?.name}
          error={formik?.errors?.name}
          onChange={formik && formik?.handleChange}
        />
        <Select
          name="status"
          label="Kiosk Status"
          className="flex-1"
          options={statuses}
          type="text"
          placeholder="Type and select Kiosk status"
          required
          value={formik?.values?.status ? { label: capitalize(formik?.values?.status) } : null}
          error={formik?.errors?.status}
          isClearable={false}
          onChange={({ value }) => formik?.setFieldValue('status', value)}
        />
      </div>

      <Textarea
        name="description"
        label="Kiosk Description"
        placeholder="Enter Kiosk description"
        textareaClassName="!h-24"
        rows={3}
        value={formik?.values?.description}
        onChange={formik && formik?.handleChange}
      />

      <Select
        name="notify_users"
        label="Members that will be notified for this kiosk’s requests"
        className="flex-1"
        isMulti
        options={practitioners}
        type="text"
        placeholder="Type and select Members"
        value={formik?.values?.notify_users}
        error={formik?.errors?.notify_users}
        isClearable={false}
        onChange={(value) => formik?.setFieldValue('notify_users', value)}
      />
    </div>
  );
}
